const state = {
    classificationScopes: [
        'unknown',
        'global_supplier',
        'product_specific',
    ],
    legislationStatuses: [
        'covered',
        'not_covered',
        'referenced',
    ],
    processStatuses: [
        'pending_machine_review',
        'pending_human_review',
        'completed',
    ],
    reviewableTypes: [
        'document_compliance',
    ],
}

const getters = {
    classificationScopes: (state) => state.classificationScopes,
    legislationStatuses: (state) => state.legislationStatuses,
    processStatuses: (state) => state.processStatuses,
    reviewableTypes: (state) => state.reviewableTypes,
}

export default {
    namespaced: true,
    state,
    getters,
}
